import { render, staticRenderFns } from "./uploader-video.vue?vue&type=template&id=6c3f1b35"
import script from "./uploader-video.vue?vue&type=script&lang=js"
export * from "./uploader-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports